/**
 * Categoria ENISA di un report SRP (CRA Art.14): vulnerabilità attivamente sfruttata oppure
 * incidente grave. I report senza categoria esplicita (storici) sono vulnerabilità attivamente
 * sfruttate (nati da KEV).
 */

export type ReportCategory = 'actively_exploited_vulnerability' | 'severe_incident';

export const REPORT_CATEGORIES: readonly ReportCategory[] = [
  'actively_exploited_vulnerability',
  'severe_incident',
];

export const REPORT_CATEGORY_LABEL: Record<ReportCategory, string> = {
  actively_exploited_vulnerability: 'Actively Exploited Vulnerability',
  severe_incident: 'Severe Incident',
};

/** Categoria effettiva di un payload, con il default per i report senza categoria. */
export function categoriaDiReport(payload: { category?: ReportCategory }): ReportCategory {
  return payload.category ?? 'actively_exploited_vulnerability';
}
